import { KeyGroup } from '@libs/types/enum'
import { speciaBehiver, specialCheckCurrent } from './limit'

export interface KeyGroupInfo {
  groupNameTranslationKey: string
  borderColor: number
  color: number
  description: string[]
}

interface KeyGroupDeadZone {
  bottom: number
}

const KEY_GROUP_NOTICE_DESCRIPTION = ['magnet_notice_desc1', 'magnet_notice_desc2', 'magnet_notice_desc3']

const createKeyGroupInfo = (
  groupNameTranslationKey: string,
  color: number,
  description: string[] = KEY_GROUP_NOTICE_DESCRIPTION,
): KeyGroupInfo => ({
  groupNameTranslationKey,
  color,
  borderColor: color,
  description,
})

const keyGroupInfoMap = new Map<KeyGroup, KeyGroupInfo>([
  [KeyGroup.cipo, createKeyGroupInfo('magnet_factory', 0xffc935, [''])],
  [KeyGroup.zixing, createKeyGroupInfo('magnet_zixing', 0xad4de3)],
  [KeyGroup.tianqing, createKeyGroupInfo('magnet_cyan', 0x50a9ee)],
  [KeyGroup.tianqing_Pro, createKeyGroupInfo('magnet_tianqing_pro', 0x85caff)],
  [KeyGroup.tianqing_SE, createKeyGroupInfo('magnet_tianqing_SE', 0xa5caff)],
  [KeyGroup.ciyu, createKeyGroupInfo('magnet_ciyu', 0x48f2bf)],
  [KeyGroup.CiyuPro, createKeyGroupInfo('magnet_CiYuPro', 0x86ffdb)],
  [KeyGroup.CiyuGaming, createKeyGroupInfo('magnet_CiYuGaming', 0x35e2ae)],
  [KeyGroup.tianwang_SE, createKeyGroupInfo('magnet_tianwang_SE', 0xff9a4d)],
  [KeyGroup.tianwang_Standard, createKeyGroupInfo('magnet_tianwang_Standard', 0xff5ad9)],
  [KeyGroup.tianwang_Esports, createKeyGroupInfo('magnet_tianwang_Esports', 0x5a86ff)],
  [KeyGroup.wanciwang, createKeyGroupInfo('magnet_wanciwang', 0xf35a5a)],
  [KeyGroup.xingguang, createKeyGroupInfo('magnet_xingguang', 0xfff570)],
  [KeyGroup.qinghui, createKeyGroupInfo('magnet_qinghui', 0xcccccc)],
  [KeyGroup.qinghui_pro, createKeyGroupInfo('magnet_qinghui_pro', 0xe4e4e4)],
  [KeyGroup.TianShanGT, createKeyGroupInfo('magnet_TianShanGT', 0xf26599)],
  [KeyGroup.BaBao, createKeyGroupInfo('magnet_BaBao', 0xbd765b)],
  [KeyGroup.Hupo, createKeyGroupInfo('magnet_Hupo', 0x8b4513)],
])

const keyGroupInfoMapWithUnknown = new Map<KeyGroup, KeyGroupInfo>([
  [KeyGroup.unknown, createKeyGroupInfo('magnet_default', 0xcccccc)],
  ...keyGroupInfoMap,
])

export const KeyGroupInfoMap = (): Map<KeyGroup, KeyGroupInfo> => {
  if (specialCheckCurrent(speciaBehiver.Device_UnknownAxis)) {
    return keyGroupInfoMapWithUnknown
  }

  return keyGroupInfoMap
}

const defaultDeadZone: KeyGroupDeadZone = { bottom: 0 }

const keyGroupDeadZoneMap = new Map<KeyGroup, KeyGroupDeadZone>([
  [KeyGroup.zixing, { bottom: 0 }],
  [KeyGroup.tianqing, { bottom: 0 }],
])

export const KeyGroupDeadZoneConfig = (keyGroup: KeyGroup): KeyGroupDeadZone => {
  return keyGroupDeadZoneMap.get(keyGroup) || defaultDeadZone
}
